<template>
  <div class="contract_info_area" id="contract_info">
    <div class="edit_area_half">
      <inputSection
        :titleLabel="corporationNameLabel"
        @inputUpdate="inputAddUpdate('corporationName')"
      ></inputSection>
      <inputSection
        :titleLabel="corporationAddressLabel"
        @inputUpdate="inputAddUpdate('corporationAddress')"
      ></inputSection>
      <inputSection
        :titleLabel="corporationUserDepartmentsLabel"
        :notRequiredFlag="true"
        @inputUpdate="inputAddUpdate('corporationUserDepartments')"
      ></inputSection>
      <inputSection
        :titleLabel="corporationUserPositionLabel"
        :notRequiredFlag="true"
        @inputUpdate="inputAddUpdate('corporationUserPosition')"
      ></inputSection>
      <inputSection
        :titleLabel="corporationUserNameLabel"
        @inputUpdate="inputAddUpdate('corporationUserName')"
      ></inputSection>
    </div>
    <div class="edit_area_half">
      <inputSection
        :titleLabel="corporationUserTelephoneNumberLabel"
        @inputUpdate="inputAddUpdate('corporationUserTelephoneNumber')"
      ></inputSection>
      <inputSection
        :titleLabel="corporationUserMailAddressLabel"
        @inputUpdate="inputAddUpdate('corporationUserMailAddress')"
      ></inputSection>
      <datepickerSection
        :titleLabel="contractDateLabel"
        :placeholderValue="placeholder"
        @inputUpdate="inputAddUpdate('contractDate')"
      ></datepickerSection>
      <inputSection
        :titleLabel="availableDeviceCountsLabel"
        @inputUpdate="inputAddUpdate('availableDeviceCounts')"
      ></inputSection>
    </div>
  </div>
</template>

<script>
import inputSection from './inputSection.vue'
import datepickerSection from './datepickerSection.vue'

export default {
  data() {
    return {
      corporationNameLabel: '法人名',
      corporationAddressLabel: '法人住所',
      contractDateLabel: '契約日',
      corporationUserDepartmentsLabel: '法人担当者（部署）',
      corporationUserPositionLabel: '法人担当者（役職）',
      corporationUserNameLabel: '法人担当者（氏名）',
      corporationUserTelephoneNumberLabel: '法人担当者連絡先（電話）',
      corporationUserMailAddressLabel: '法人担当者連絡先（メール）',
      availableDeviceCountsLabel: '契約台数',
      placeholder: 'Select Date'
    }
  },
  components: {
    inputSection,
    datepickerSection
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('corporations/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/contractAddInfo.vue